const chimneyService = {
  title: "Chimney Service",
  icon: "🌫️",
  rateCardKey: "chimney",
  shortDescription:
    "Kitchen chimney cleaning, suction issue checks, and installation support.",
  longDescription:
    "Book chimney support for deep cleaning, suction issue review, maintenance visits, and installation assistance.",
  consultationNote:
    "Motor, PCB, or advanced suction failures may require inspection before exact quote.",
  responsePromise:
    "Assignment depends on chimney type and cleaning or repair scope.",
  warrantyPolicy:
    "Cleaning and repair outcomes depend on oil buildup, motor condition, and filter state.",
  subServices: [
    {
      id: "chimney-deep-cleaning",
      title: "Chimney Deep Cleaning",
      icon: "🧼",
      group: "Service",
      description:
        "Deep cleaning support for oil and grease buildup in home chimney units.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "Service completion only",
      unit: "job",
    },
    {
      id: "chimney-suction-check",
      title: "Suction Issue Inspection",
      icon: "🌬️",
      group: "Inspection",
      description:
        "Inspection for low suction, unusual sound, or performance issues.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "chimney-filter-support",
      title: "Filter Cleaning / Support",
      icon: "🪞",
      group: "Service",
      description:
        "Support for filter-side cleaning and maintenance review.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "30-45 mins",
      warranty: "Service completion only",
      unit: "job",
    },
    {
      id: "chimney-installation",
      title: "Chimney Installation Support",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic installation support for chimney setups subject to site suitability.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "60-120 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default chimneyService;